import { Box } from "@mui/material";
import LoadingPlaceholderBlock from "components/common/LoadingPlaceholderBlock";

export default function MessageListLoader() {
  return (
    <>
      {[...new Array(10)].map((_, index) => (
        <Box
          key={index}
          sx={{
            borderBottom: "1px solid #f0ece5",
            height: "76.42px",
            padding: "16px 20px 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              flex: 1,
            }}
          >
            <LoadingPlaceholderBlock
              width={"150px"}
              height={"15px"}
              borderRadius={"5px"}
              backgroundColor={"#d7d6d6"}
            />
            <LoadingPlaceholderBlock
              width={"100%"}
              height={"14px"}
              borderRadius={"5px"}
              backgroundColor={"#d7d6d6"}
            />
          </Box>

          <Box>
            <LoadingPlaceholderBlock
              width={"50px"}
              height={"12px"}
              borderRadius={"5px"}
              backgroundColor={"#d7d6d6"}
            />
          </Box>
        </Box>
      ))}
    </>
  );
}